import { memo } from "react";
import { Card } from "@/components/Shared/UI";
import cn from "@/helpers/cn";
import PostShimmer from "./PostShimmer";

interface PostsShimmerProps {
  hideCard?: boolean;
}

const PostsShimmer = ({ hideCard = false }: PostsShimmerProps) => {
  if (hideCard) {
    return (
      <div className="divide-y divide-gray-200 dark:divide-gray-700">
        {Array.from({ length: 3 }).map((_, index) => (
          <PostShimmer key={index} />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-3 px-3">
      {Array.from({ length: 3 }).map((_, index) => (
        <Card key={index} className="mb-3">
          <PostShimmer />
        </Card>
      ))}
    </div>
  );
};

export default memo(PostsShimmer);
